import { useEffect, useRef } from 'react';

function useOnce(callback, deps) {
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			callback();
		}
	}, deps);

	useEffect(() => {
		isFirstRender.current = false;
	}, []);
}

export default useOnce;
